<div class="card">
  <div class="container">
    <div class="row justify-content-center" *ngIf="!ehMobile">
      <img src="assets/img/home/bgFull.png" style="display: block">
    </div>
    <div class="row justify-content-center" *ngIf="ehMobile">
      <img src="assets/img/home/bgMobile.png" style="display: block">
    </div>
  </div>
</div>